export default __webpack_public_path__ + "static/media/landingpage_hero.4757b834.svg";